import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/sirc-public/src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {

  private _environment: any = null;

  constructor(private http: HttpClient) {
    /** Configuration par défaut, pour les tests */
    this._environment = { 'socleBaseUrl': 'http://localhost:8081/api' };
  }

  /** @description : chargement du fichier "environment.json" pour la configuration initiale */
  public load(): Promise<any> {
    return this.http.get(environment.hrefBase + '/assets/config/environment.json').toPromise().then(data => {
      this._environment = data;
    }).catch((error) => {
      throw error;
    });
  }

  getEnvironment(): any {
    return this._environment;
  }
}
